import { NavigationExtras } from '@angular/router';
import { APP_TOP_LEVEL_PATH } from '@epicuro-next/navigation/constants';
import { ROUTER_OUTLET_KEY } from '@epicuro-next/state/router-store';

export function getSiteIdFromParam(url: string): string | undefined {
  const urlArr = url.split('/');
  const idx = urlArr.findIndex(
    (path) => path === APP_TOP_LEVEL_PATH.siteSelector.custom,
  );
  return idx === -1 ? undefined : urlArr[idx + 1]; // will be following item in urlArr
}

export function skipMultiBrandSiteSelectorLogic(
  url: string,
  extras?: NavigationExtras,
): boolean {
  return (
    url.includes(APP_TOP_LEVEL_PATH.siteSelector.path) ||
    url.includes(APP_TOP_LEVEL_PATH.accountSelector.path) ||
    url.includes(APP_TOP_LEVEL_PATH.userTerms.path) ||
    url.includes(APP_TOP_LEVEL_PATH.authentication.path) ||
    url.includes(APP_TOP_LEVEL_PATH.offboarding.path) ||
    extras?.state?.[ROUTER_OUTLET_KEY] === true
  );
}

const SUB_SITE_URL_DIVIDER = ':';

export function siteSliceUrlBuilder(
  site: string,
  subSite?: string | null,
): string {
  if (!subSite) {
    return site;
  }
  return `${site}${SUB_SITE_URL_DIVIDER}${subSite}`;
}

export function sitesArePresentInTheStartOfTheUrl(
  url: string,
  siteId: string,
  subSiteId: string | null = null,
) {
  const checkUrl = url.startsWith('/') ? url.substring(1, url.length) : url;
  let match = `${APP_TOP_LEVEL_PATH.siteSelector.custom}/${siteId}`;
  if (subSiteId) {
    match += `:${subSiteId}`;
  }
  return checkUrl.indexOf(match) === 0;
}

export function getCurrentSiteUrl(
  siteIdSubUrl?: string,
): [string, string | undefined] | undefined {
  if (!siteIdSubUrl) {
    return undefined;
  }
  const siteUrlArr = siteIdSubUrl.split(SUB_SITE_URL_DIVIDER);
  // [siteId, possibleSelected subSiteId]
  return [siteUrlArr[0], siteUrlArr[1]];
}
